import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './about.vue'
import AboutUs from './component/aboutUs'
import ContactUs from './component/contactUs'
import Online from './component/online'
import HttpDemo from './component/http'
import '../common/main.js'

Vue.use(VueRouter)

const routes = [
  { path: '/aboutUs', component: AboutUs },
  { path: '/contactUs', component: ContactUs },
  { path: '/online', component: Online},
  { path: '/http', component: HttpDemo}
]

const router = new VueRouter({
  routes
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<Account-App/>',
  components: { 'Account-App': App }
})



// WEBPACK FOOTER //
// ./src/modules/about/about.js